<template>
  <section
    v-if="variants.v1 === variant"
    class="tw-items-center tw-justify-center tw-py-24"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'} `"
  >
    <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="600" is="div">
      <h2 class="tw-text-3xl tw-font-bold lg:tw-text-4xl" style="line-height: 180%">
        {{ vars.titleText }}
      </h2>
    </MotionGroup>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="tw-items-center tw-justify-center tw-gap-10 tw-py-24 lg:tw-flex-row"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'} `"
  >
    <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="600" is="div">
      <h2>
        {{ vars.titleText }}
      </h2>
    </MotionGroup>
    <MotionGroup
      class="tw-flex tw-w-full tw-items-center tw-justify-center"
      :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'"
      :duration="600"
      is="div"
    >
      <nuxt-link :to="vars.buttonLinkUrl" :external="true" :class="`n-${vars.buttonTypeText} tw-w-full tw-text-center md:tw-w-auto`">
        {{ vars.buttonLabelText }}</nuxt-link
      >
    </MotionGroup>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TextBanner',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: { v1: 'v1', v2: 'v2' },
    };
  },
});
</script>
